var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9485 3.125C18.4495 3.11736 20.9021 3.75848 23.0243 4.97466C25.1466 6.19084 26.8522 7.9327 27.9453 10C25.701 14.2125 21.1172 16.875 15.9485 16.875C10.7799 16.875 6.19606 14.2125 3.95176 10C5.04482 7.9327 6.75051 6.19084 8.87272 4.97466C10.9949 3.75848 13.4475 3.11736 15.9485 3.125ZM15.9485 0.625C9.14764 0.625 3.33968 4.5125 0.986572 10C3.33968 15.4875 9.14764 19.375 15.9485 19.375C22.7494 19.375 28.5574 15.4875 30.9105 10C28.5574 4.5125 22.7494 0.625 15.9485 0.625ZM15.9485 6.875C16.8504 6.875 17.7153 7.20424 18.353 7.79029C18.9907 8.37634 19.349 9.1712 19.349 10C19.349 10.8288 18.9907 11.6237 18.353 12.2097C17.7153 12.7958 16.8504 13.125 15.9485 13.125C15.0467 13.125 14.1818 12.7958 13.5441 12.2097C12.9063 11.6237 12.5481 10.8288 12.5481 10C12.5481 9.1712 12.9063 8.37634 13.5441 7.79029C14.1818 7.20424 15.0467 6.875 15.9485 6.875ZM15.9485 4.375C12.5753 4.375 9.82773 6.9 9.82773 10C9.82773 13.1 12.5753 15.625 15.9485 15.625C19.3218 15.625 22.0693 13.1 22.0693 10C22.0693 6.9 19.3218 4.375 15.9485 4.375Z",
    fill: "#0F2D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeview);
export default __webpack_public_path__ + "static/media/eyeview.fb5b0ae4fb36b0a6f0765df4a2aa0540.svg";
export { ForwardRef as ReactComponent };